import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ApplicationInsightsService } from './application-insights';

@Injectable()
export class SpaqErrorHandler implements ErrorHandler {
	static readonly CHUNK_RELOAD_KEY = 'spaq.chunkReload';

	constructor(private injector: Injector) {}

	handleError(error: unknown): void {
		if (error instanceof Error && error.message.includes('ExpressionChangedAfterItHasBeenCheckedError')) {
			return;
		}

		const chunkError = this.getChunkLoadError(error);
		if (chunkError) {
			this.handleChunkLoadError(chunkError);
			return;
		}

		console.error(error);
		this.injector.get(ApplicationInsightsService).trackException(error instanceof Error ? error : new Error(String(error)));
	}

	private getChunkLoadError(error: unknown): Error | null {
		const wrapped = error as { rejection?: unknown; promise?: { rejection?: unknown }; error?: unknown } | null;
		const candidates = [error, wrapped?.rejection, wrapped?.promise?.rejection, wrapped?.error];

		for (const candidate of candidates) {
			if (this.isChunkLoadError(candidate)) {
				return candidate instanceof Error ? candidate : new Error(String(candidate));
			}
		}

		return null;
	}

	private isChunkLoadError(error: unknown): boolean {
		if (error == null) {
			return false;
		}

		const name = (error as { name?: string }).name || '';
		const message = String((error as { message?: string }).message || error);

		return (
			name === 'ChunkLoadError' ||
			/Loading chunk [\w-]+ failed/i.test(message) ||
			message.includes('Failed to fetch dynamically imported module')
		);
	}

	private handleChunkLoadError(error: Error): void {
		console.error(error);

		const alreadyReloaded = sessionStorage.getItem(SpaqErrorHandler.CHUNK_RELOAD_KEY) === '1';
		const insights = this.injector.get(ApplicationInsightsService);

		if (!alreadyReloaded) {
			sessionStorage.setItem(SpaqErrorHandler.CHUNK_RELOAD_KEY, '1');
			insights.trackException(error, { chunkLoadRecovery: 'reload' });
			window.location.reload();
			return;
		}

		insights.trackException(error, { chunkLoadRecovery: 'already-reloaded' });
	}
}
